import { render, staticRenderFns } from "./ReceiptDashboard.vue?vue&type=template&id=3ad89047"
import script from "./ReceiptDashboard.vue?vue&type=script&lang=js"
export * from "./ReceiptDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports